<div class="ellipsis-loader" [class.d-none]="!show">
  <span class="dot"></span>
  <span class="dot"></span>
  <span class="dot"></span>
</div>
